import React from 'react'

export default function (propriedades) {
  return (
    <footer className='footer'>
      <img src='imgs/evnts.png' alt='' />
    </footer>
  )
}
